import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import {
    API_CREATE_PARAMETER,
    API_EDIT_PARAMETER, API_GET_PARAMETER,
    API_SHOW_PARAMETER
} from "../../../../constants/apiSuffix";
import {
    arrShareDocumentExpireNumberDay, FORM_CREATE,
    FORM_EDIT,
    NUMBER, NUMBER_OF_DAYS_ARCHIVE_REQUEST,
    STRING,
} from "../../../../constants/constants";
import CustomInput from "../../../../theme/CustomElements/CustomInput";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {withRouter} from "react-router-dom";
import {withStyles} from "@material-ui/core/styles";
import RowFormColumn from "../../../../theme/form/RowFormColumn";
import CustomButton from "../../../../theme/CustomElements/CustomButton";
import qs from "qs";
import {formDataValue} from "./ParameterPage";
import {Redirect} from "react-router";
import SaveIcon from '@material-ui/icons/Save';
import LoadingAction from "../../../../theme/LoadingAction";
import AlertCustom from "../../../../theme/form/Alert/AlertCustom";
import {checkSubmitSendDataERROR} from "../../../../functions/checkCondition";
import ErrorInput from "../../../../theme/form/Alert/ErrorInput";
import { cleanHTML } from "../../../../functions/functions";

const styles = {
    numberDaysWrapper: {
        '& .validateCustom': {
            paddingLeft: 5,
        }
    },
    numberDays: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-start',
        maxWidth: 260,
        '& .rowFormColumn': {
            paddingBottom: 0
        },
        '& .unitText': {
            fontSize: '1rem',
            paddingLeft: '0.5rem',
            fontWeight: 600,
            marginBottom: 8,
        },
    },
    btnResponse: {
        background: '#0000ff !important',
        margin: '1.5rem 5px 0 5px',
        minHeight: 40
    },
};

const headLabel = "reactAdmin.parameter.form.";
export const NUMBER_OF_DAYS_ARCHIVE_REQUEST_AND_SEND_SMS_EMAIL = 'number_of_days_archive_request_and_send_sms_email';

const arrForm = [
    {
        name: "description",
        type: STRING,
        label: `${headLabel}description`
    },
    {
        name: "value",
        type: NUMBER,
        label: `${headLabel}value`
    }
]

class FormDayParameter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formValue: formDataValue,
            errors: {},
            redirectUrl: "",
            successOpen: false,
            errorOpen: false,
        };
        this.propertiesForm = [];
    }

    handleCloseNotice = () => {
        this.setState({
            successOpen: false,
            errorOpen: false
        })
    }

    handleChange = (value, field) => {
        let {formValue, errors} = this.state;
        if (errors.hasOwnProperty(field)) {
            delete (errors[field]);
        }
        formValue[field] = value;
        this.setState({formValue: formValue, errors: errors})
    }


    getShowDataParameter = (idParameter) => {
        const url = API_SHOW_PARAMETER.replace("{id}", idParameter);
        axios.get(url)
            .then(response => {
                if (response.status === 200) {
                    let formValueNew = {...this.state.formValue};
                    const dataValue = response.data;
                    let valueData = dataValue.value ? dataValue.value : "";

                    formValueNew = {
                        ...formValueNew,
                        code: dataValue.code ?? "",
                        value: valueData,
                        description: dataValue.description ?? "",
                    }
                    this.setState({
                        formValue: formValueNew,
                        formType: FORM_EDIT,
                        isLoading: false
                    })
                }
            })
            .catch(() => {
                this.setState({
                    formType: FORM_EDIT,
                    isLoading: false
                })
            })
    }

    componentDidMount() {
        const {match, location} = this.props;
        const arrayParams = [NUMBER_OF_DAYS_ARCHIVE_REQUEST]
        const filterGetCodeByUrl = arrayParams.filter(item => location.pathname.startsWith(`/${item}`))
        const codePathName = filterGetCodeByUrl.shift();
        this.propertiesForm = codePathName === NUMBER_OF_DAYS_ARCHIVE_REQUEST ? arrShareDocumentExpireNumberDay : [];
        this.setState({
            isLoading: true
        })
        if (match && match.params && match.params.id) {
            this.getShowDataParameter(match.params.id)
        } else {
            const codeDefault = codePathName === NUMBER_OF_DAYS_ARCHIVE_REQUEST ? NUMBER_OF_DAYS_ARCHIVE_REQUEST_AND_SEND_SMS_EMAIL : codePathName

            let query = {code: codeDefault}

            const url = API_GET_PARAMETER + `?${qs.stringify(query)}`;
            axios.get(url)
                .then(response => {
                    if (response.status === 200) {
                        let formValueNew = {...this.state.formValue};
                        formValueNew.code = codeDefault;
                        if (response.data.items.length > 0) {
                            const dataValue = response.data.items[0];
                            formValueNew = {
                                ...formValueNew,
                                code: dataValue.code ?? "",
                                value: dataValue.value ?? "",
                                description: dataValue.description ?? "",
                            }
                        }
                        this.setState({
                            formType: FORM_CREATE,
                            formValue: formValueNew,
                            isLoading: false

                        })
                    } else {
                        throw new Error();
                    }
                })
                .catch(error => {
                    this.setState({
                        formType: FORM_CREATE,
                        formValue: {
                            ...this.state.formValue,
                            code: codeDefault
                        },
                        isLoading: false
                    })
                });
        }
    }

    handleSave = (e) => {
        const {match} = this.props;
        let {formValue, errors} = this.state;
        Object.keys(this.state.formValue).map((key) => {
            if (this.propertiesForm.includes(key)) {
                switch (key) {
                    case "value":
                        if (!this.state.formValue[key]) {
                            errors = {...errors, [key]: this.props.t("form.error.NOT_NULL")}
                        }
                        break;
                    default:
                        break;
                }
            }
        });

        if (formValue["value"]) {
            errors = checkSubmitSendDataERROR(formValue["value"], NUMBER, errors, "value", ("errors.isNotValid"), this.props.t)
        }

        if (Object.keys(errors) < 1) {
            this.setState({isLoading: true})
            let url = API_CREATE_PARAMETER;
            const formData = new FormData();
            if (this.props.formType === FORM_EDIT || (match && match.params && match.params.id)) {
                url = API_EDIT_PARAMETER.replace("{id}", match.params.id)
            } else {
                formData.append("code", this.state.formValue.code);
            }

            Object.keys(this.state.formValue).map((key) => {
                if (this.propertiesForm.includes(key)) {
                    switch (key) {
                        case "value":
                            formData.append(key, formValue[key] ? formValue[key] : "");
                            break;
                        case "description":
                            formData.append(key, cleanHTML(this.state.formValue[key] ?? ""));
                            break;
                        default:
                            break;
                    }
                }
            });
            axios.post(url, formData)
                .then(response => {
                    if (response.status === 200) {
                        const dataItemResponse = response.data.item;
                        this.setState({
                            errors: {},
                            successOpen: true,
                        })
                        this.getShowDataParameter(dataItemResponse.id)
                    }
                })
                .catch(error => {
                    this.setState({
                        isLoading: false,
                        errorOpen: true
                    })
                })
        } else {
            this.setState({
                isLoading: false,
                errors: errors,
                errorOpen: true
            })
        }
    }


    render() {
        const {formValue, errors, redirectUrl, isLoading, formType} = this.state;
        const {t, classes} = this.props;
        if (redirectUrl) {
            if (formType === FORM_EDIT) {
                this.setState({isLoading: true})
            }
            return <Redirect to={redirectUrl}/>;
        }

        return (
            <div>
                {isLoading && <LoadingAction/>}
                <AlertCustom
                    successOpen={this.state.successOpen}
                    errorOpen={this.state.errorOpen}
                    handleCloseNotice={() => this.handleCloseNotice()}
                />
                {arrForm.map((item, key) => {
                    if (this.propertiesForm.includes(item.name)) {
                        switch (item.type) {
                            case STRING:
                                return (<RowFormColumn
                                    label={t(item.label)}
                                    key={key}
                                    input={<CustomInput
                                        name={item.name}
                                        value={formValue[item.name]}
                                        onChange={(e) => this.handleChange(e.target.value, item.name)}
                                        validate={errors[item.name]}
                                    />}
                                    textValidate={errors[item.name]}
                                />);

                            case NUMBER:
                                return <div key={key} className={classes.numberDaysWrapper}>
                                    <div
                                        className={`${classes.numberDays} ${errors[item.name] ? "errorWrapper" : ""}`}>
                                        <RowFormColumn
                                            key={key}
                                            label={t(item.label)}
                                            input={<CustomInput
                                                type={item.type}
                                                name={item.name}
                                                value={formValue[item.name]}
                                                onChange={(e) => this.handleChange(e.target.value, item.name)}
                                                validate={errors[item.name]}
                                                textValidate={errors[item.name]}
                                            />}
                                        />
                                        <div className={"unitText"}>{t("text.unitDays")}</div>
                                    </div>
                                    <ErrorInput textValidate={errors[item.name]}/>
                                </div>;
                            default:
                                return "";
                        }
                    }
                })}

                <CustomButton
                    className={classes.btnResponse}
                    title={this.props.t("button.save")}
                    buttonProps={{
                        startIcon: <React.Fragment><SaveIcon className={"iconAdd"}/></React.Fragment>
                    }}
                    onClick={this.handleSave}/>

            </div>
        )
    }
}

FormDayParameter.propTypes = {
    classes: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired
};

export default compose(
    withStyles(styles),
    withTranslation(),
    withRouter
)(FormDayParameter);
